import { Component, Input, OnDestroy, OnInit, forwardRef, ChangeDetectionStrategy } from '@angular/core'
import { ControlValueAccessor, FormBuilder, NG_VALUE_ACCESSOR } from '@angular/forms'
import { List } from 'immutable'
import { Integration } from 'src/app/account/services/account.service'

@Component({
  selector: 'application-integrations-form-control',
  templateUrl: './application-integrations-form-control.component.html',
  styleUrls: ['./application-integrations-form-control.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => ApplicationIntegrationsFormControlComponent),
      multi: true,
    },
  ],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class ApplicationIntegrationsFormControlComponent implements OnInit, OnDestroy, ControlValueAccessor {
  private selectedIntegrations = new Set<string>()
  private onChangeFunction: any = null

  @Input() accountIntegrations: Array<Integration> = []
  sortedIntegrations: List<Integration> = null

  constructor() {}

  ngOnInit(): void {
    function integrationSortFunc(l: Integration, r: Integration) {
      if (l.config.getTypeDisplayString() < r.config.getTypeDisplayString()) {
        return -1
      }
      if (l.config.getTypeDisplayString() > r.config.getTypeDisplayString()) {
        return 1
      }
      return l.name < r.name ? -1 : 1
    }
    // Sort this once and store as an immutable List
    this.sortedIntegrations = List<Integration>(this.accountIntegrations.sort(integrationSortFunc))
  }

  ngOnDestroy(): void {}

  writeValue(integrationIds: Set<string>): void {
    this.selectedIntegrations = integrationIds
  }

  registerOnChange(fn: any): void {
    this.onChangeFunction = fn
  }

  registerOnTouched(fn: any): void {}

  toggleIntegration(integration: Integration, event) {
    if (this.selectedIntegrations.has(integration.integrationId)) {
      this.selectedIntegrations.delete(integration.integrationId)
    } else {
      this.selectedIntegrations.add(integration.integrationId)
    }

    this.onChangeFunction(this.selectedIntegrations)
  }

  integrationChecked(integration: Integration) {
    return this.selectedIntegrations.has(integration.integrationId)
  }
}
